// The four ways the Umami half of /admin/stats can come back with nothing,
// resolved in one place rather than as four ifs inside the renderer.
//
// Kept in its own module, with no import of the ApexCharts wrapper: stats.js
// pulls in `apexcharts/dist/apexcharts.css`, which a plain `node --test` run
// has no loader for, so a module that stays free of that chain is the only
// part of this page a unit test can import directly.
//
// Order matters and is the whole point of the function existing:
//
// - `admin()` (app/admin-api.js) swallows any non-2xx response into `[]` —
//   an expired moderator session or a 500 from the Umami read looks like an
//   array, never the object shape a real answer takes. Checked first, or a
//   failed request falls through `!stats?.enabled` and reports a
//   configuration switch that was never touched.
// - ANALYTICS=on with no UMAMI_TOKEN answers `configured: false` *and*
//   `summary: null` at once, because readStats() refuses before it asks
//   Umami anything. Checking `summary` before `configured` would read that
//   as "the box is down", which sends a moderator to wait out an outage that
//   is actually a missing env var.
export function statsState(stats) {
  if (Array.isArray(stats)) return 'failed';
  if (!stats?.enabled) return 'off';
  if (!stats.configured) return 'no-token';
  if (!stats.summary) return 'unreachable';
  return 'ok';
}
